export const messages = {
  HOME: {
    TITLE: "Dashboard",
    ROUTE: "/dashboard",
    PAGE: "Welcome to Mithril App",
    INTRO:
      "A powerful single-page application framework built with Mithril.js and TypeScript",
    SECTION1_TITLE: "Features",
    SECTION1:
      "This application demonstrates modern web development with Mithril.js, featuring reactive state management, internationalization support, and a modular component architecture.",
    SECTION2_TITLE: "Technology Stack",
    SECTION2:
      "Built with TypeScript for type safety, Rspack for fast builds, and Materialize CSS for a responsive user interface. The Meiosis pattern ensures predictable state transitions.",
    SECTION3_TITLE: "Usage",
    SECTION3:
      "Navigate through the sections using the navigation bar. Use the search function to find content across all pages. Switch languages to experience the internationalization features.",
  },
  ABOUT: {
    TITLE: "About the app",
    ROUTE: "/about",
    PAGE: "About Mithril App",
    INTRO: "Learn more about this Mithril.js application and its development",
    SECTION1_TITLE: "What is Mithril.js",
    SECTION1:
      "Mithril is a modern client-side JavaScript framework for building powerful single-page applications. It offers a compact API, virtual DOM implementation, and routing out of the box.",
    SECTION2_TITLE: "Key Features",
    SECTION2:
      "This application demonstrates Mithril capabilities including reactive state management, internationalization, type-safe TypeScript development, and modular component architecture.",
    SECTION3_TITLE: "Development Goals",
    SECTION3:
      "The goal of this project is to provide a clean, maintainable codebase that showcases modern web development patterns with Mithril.js as an alternative to heavier frameworks.",
  },
  SETTINGS: {
    TITLE: "Settings",
    ROUTE: "/settings",
    PAGE: "Application Settings",
    INTRO: "Configure your application preferences and language settings",
    SECTION1_TITLE: "Language Preferences",
    SECTION1:
      "Switch between English and Dutch. Your preference is saved to localStorage and persists across sessions.",
    SECTION2_TITLE: "Theme Settings",
    SECTION2:
      "Customize the visual appearance of the application. Adjust colors, fonts, and layout preferences to match your workflow.",
    SECTION3_TITLE: "Preferences",
    SECTION3:
      "Manage application behavior including default views, data persistence options, and notification settings.",
  },
  LANDING: { TITLE: "Introduction", ROUTE: "/" },
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  HAZARDS: { TITLE: "Hazards", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Solutions", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Roadmap", ROUTE: "/roadmap" },
  USER: "User",
  EDITOR: "Editor",
  ADMIN: "Administrator",
  FACILITATOR: "Facilitator",
  CANCEL: "Cancel",
  DELETE: "Delete",
  YES: "Yes",
  NO: "No",
  OK: "Ok",
  NAME: "Name",
  DESCRIPTION: "Description",
  DELETE_ITEM: {
    TITLE: "Delete {item}",
    DESCRIPTION:
      "Are you certain you want to delete this {item}. There is no turning back?",
  },
  SAVE_BUTTON: {
    LABEL: "Save",
    TOOLTIP: "Save unsaved changes",
  },
  SEARCH: "Search...",
  SEARCH_TOOLTIP: "Type / to search",
  LANGUAGE: "Language",
  CLEAR: "Clear model",
  UPLOAD: "Upload model as JSON",
  DOWNLOAD: "Download model as JSON",
  PERMALINK: "Create permanent link",
  ROLE: "Role",
  LINK: "Link",
  MODEL: "Model",
  TITLE: "Title",
  AUTHORS: "Authors",
  TYPE: "Type",
  HITS: {
    n: "{n} Hits",
  },
  NO_RESULTS: "No results found",
  CLEAR_SEARCH: "Clear search",
  PAGE_NOT_FOUND: "Page Not Found",

  about_route: "/about",
  about: "About",
  acronym: "Acronym",
  add_term: "Add a new term",
  addr_how: "How is it addressed?",
  addressed: "Addressed",
  ass_instr:
    "_Assess the contribution of a capability towards your goals, and the room for improvement._",
  ass_label: "Problem cause is well known",
  ass_overall: "Need for improvement",
  ass_scale: "Scale for assessment score",
  ass_setting: "Assessment matrix",
  ass: "Assessment",
  assess_content:
    "Determine for each capability how important it is, and your current performance, so you can prioritise and focus on the ones you really need.",
  assess: "Assess",
  assessment_route: "/assessment/:id",
  assessment: "Assessment",
  avg_perf: "Overall assessment",
  cap_cat: "Capability category",
  cap: "Capability",
  caps: "Capabilities",
  cat: "Category",
  clear_all: "Clear all filters",
  clear: "Clear",
  color: "Colour",
  create_cap: "Create capability",
  defs: "Definitions",
  del_model: "Do you really want to delete everything?",
  del_model_desc: "Are you sure that you want to delete your model?",
  del_proj: "Delete project",
  desc_cap_instr: "Describe the capability in detail.",
  desc: "Description",
  develop_content:
    "Start working on developing your capabilities, alone or with other organisations, and create your roadmap.",
  develop: "Develop",
  development: "Development",
  development_route: "/development/:id",
  dev_cap:
    "_Suggest new projects to develop your capability. Start by selecting a capability._",
  doc_id: "Document ID",
  doc: "Documentation",
  download: "Download",
  duration: "Duration",
  edit: "Edit",
  view: "View",
  evaluation_route: "/evaluation/:id",
  evaluation: "Evaluation",
  exp_perf: "Expected performance",
  expl: "Explanation",
  expl2: "Performance",
  filter_cap: "Filter capabilities",
  filter_caps: "Filter capabilities",
  filter_ph: "Title or description",
  filter_text_ph: "Term or description",
  filter_text: "Filter text",
  filters: "Filters",
  relevance: "Relevance",
  gap_scale: "Scale for the gap",
  gap_settings: "##### Gaps settings",
  gap: "Gap",
  gaps_common: "Common gaps or causes of problems",
  gaps: "Gaps",
  gng: "###### GO / NO GO decision<br>",
  go: "GO",
  goal_scale: "Scale for the assessment themes",
  goals_instr: "Specify long and short term goals",
  goal: "Goal",
  goals: "Goals",
  group_goals_instr:
    "1. **Set the group goals that you want to achieve.**\n2. Specify your stakeholders and specify their organizational goals.\n3. Specify capability categories to organize the capabilities.\n4. Specify the capabilities that you need to achieve the group goals.",
  group_goals: "Specify group goals",
  home_route: "/",
  home: "HOME",
  id: "ID",
  importance: "Importance",
  in_months: "In months",
  loc: "Room/location",
  main_goals: "Goals",
  assess_capability_importance_for_capability:
    'Assess the importance of "{capability}" for the chosen scope.',
  max_imp: "Maximum contribution",
  name: "Name",
  no_go: "NO GO",
  no: "No",
  org_dept: "Organisatie / Afdeling",
  overview_route: "/overview",
  overview: "Overview",
  level: "Level",
  perf_asp: "Performance aspect",
  perf_asps: "Performance aspects",
  assess_performance_aspects_for_capability:
    "Assess the Performance Aspects of {capability}.",
  perf_effectiveness_tooltip: "How effective is {capability}?",
  perf_safety_professionals_tooltip:
    "What is the level of the physical and mental safety of operational personnel working on {capability}?",
  perf_efficiency_tooltip: "How efficient is {capability}?",
  perf_scale: "Scale for performance score",
  perf_settings: "##### Assessment settings",
  perf: "Performance",
  period: "YYYY Q1 or YYYY M1",
  permalink: "Permalink",
  pers_inv: "Persons involved",
  pick_more: "Pick one or more",
  pick_one: "Pick one",
  prep_content:
    "_Define your organisation's goals, and your most important capabilities._",
  preparation_route: "/preparation",
  preparation: "Preparation",
  prepare_content:
    "Create or select the capabilities that are important for your organisation.",
  prepare: "Prepare",
  prob_areas: "Problem areas",
  gap_problem_categories_intro:
    "Analyse this capability gap on the following problem categories.",
  gap_likert_severity: "Severity",
  gap_likert_severity_start_label: "Very low",
  gap_likert_severity_middle_label: "Average",
  gap_likert_severity_end_label: "Very high",
  gap_likert_probability: "Probability",
  gap_likert_probability_start_label: "No change",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Big decrease",
  gap_likert_impact: "Impact",
  gap_likert_impact_start_label: "No change",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Big decrease",
  gap_likert_severity_tooltip:
    "How do you rate the severity of this capability gap?",
  gap_likert_probability_tooltip:
    "Suppose the gap is solved: What would this mean for the probability of occurrence of the gap?",
  gap_likert_impact_tooltip:
    "Suppose the gap is solved. What would this mean for the reduction in impact of the original gap?",
  prob: "Problem",
  proj_app: "###### PROJECT APPROVED<br>",
  proj_name: "Project name",
  proj_prop: "New project or proposal",
  proj_sum: "Project summary",
  prop_name: "Proposal name",
  prop_new: "New proposal",
  ref: "Reference",
  ref_url: "Reference URL",
  select_cap: "Select capability",
  select_cat: "Select category",
  select_m_ph: "Select one or more",
  select_subcat: "Select subcategory",
  settings_route: "/settings",
  settings: "Settings",
  sh_filter: "Filter involved organisations",
  sh_org: "Stakeholder organisations",
  sh_settings: "##### Stakeholder/stakeholder settings",
  sh_type: "Type of stakeholder",
  sh_types: "Stakeholder types",
  sh: "Stakeholder",
  shs: "Stakeholders",
  other_stakeholder: "Please describe the other stakeholder",
  spec_cap_instr:
    "1. Set the group goals that you want to achieve.\n2. Specify your stakeholders and specify their organizational goals.\n3. Specify capability categories to organize the capabilities.\n4. **Specify the capabilities that you need to achieve the group goals.**",
  spec_cap: "Specify capabilities",
  spec_cat_instr:
    "1. Set the group goals that you want to achieve.\n2. Specify your stakeholders and specify their organizational goals.\n3. **Specify capability categories to organize the capabilities.**\n4. Specify the capabilities that you need to achieve the group goals.",
  spec_cat: "Specify categories",
  spec_sh_instr:
    "1. Set the group goals that you want to achieve.\n2. **Specify your stakeholders and specify their organizational goals.**\n3. Specify capability categories to organize the capabilities.\n4. Specify the capabilities that you need to achieve the group goals.",
  spec_sh: "Specify stakeholders",
  start_time: "Start time",
  subcat: "Subcategory",
  task_settings: "##### Task settings",
  task: "Task",
  task2perf: "##### Task to performance table lookup",
  tasks: "Tasks",
  ass_task_scale: "Task scale",
  ass_perf_scale: "Performance",
  taxonomy_route: "/taxonomy",
  taxonomy: "Taxonomy",
  tax_def:
    "#### Taxonomy\n\nDefinitions and abbreviations of commonly used words.",
  TAXONOMY: {
    HAZARD: "Hazard",
    HAZARD_DEF:
      "A process, phenomenon, or human activity that can cause loss of life, injury, disruption, or environmental damage.",
    HAZARD_TYPE: "Hazard type",
    HAZARD_TYPE_DEF:
      "A class of hazards with similar origin or characteristics, such as natural, technological, or human-induced hazards.",
    DISASTER: "Disaster",
    DISASTER_DEF:
      "A serious disruption of a community or society that exceeds its capacity to cope using its own resources.",
    EMERGENCY: "Emergency",
    EMERGENCY_DEF:
      "A situation requiring immediate coordinated action to protect life, health, property, or the environment.",
    DISASTER_RISK: "Disaster risk",
    DISASTER_RISK_DEF:
      "The potential for losses from hazardous events, shaped by hazard, exposure, vulnerability, and capacity.",
    EXPOSURE: "Exposure",
    EXPOSURE_DEF:
      "The presence of people, assets, infrastructure, and services in places where hazards may occur.",
    VULNERABILITY: "Vulnerability",
    VULNERABILITY_DEF:
      "Conditions that increase susceptibility of people, assets, or systems to hazard impacts.",
    CAPACITY: "Capacity",
    CAPACITY_DEF:
      "The strengths and resources available to anticipate, cope with, resist, and recover from hazard impacts.",
    CAPABILITY: "Capability",
    CAPABILITY_DEF:
      "A specific, demonstrable ability of an organisation to perform tasks and achieve outcomes under defined conditions.",
    RESILIENCE: "Resilience",
    RESILIENCE_DEF:
      "The ability of systems and communities to resist, absorb, adapt, and recover while preserving essential functions.",
    PREVENTION: "Prevention",
    PREVENTION_DEF:
      "Actions to avoid the creation of new risks and prevent hazards from causing harmful impacts.",
    MITIGATION: "Mitigation",
    MITIGATION_DEF:
      "Measures that reduce the severity or likelihood of adverse impacts from hazardous events.",
    PREPAREDNESS: "Preparedness",
    PREPAREDNESS_DEF:
      "Knowledge, plans, and capacities developed in advance to enable effective anticipation, response, and recovery.",
    EARLY_WARNING_SYSTEM: "Early warning system",
    EARLY_WARNING_SYSTEM_DEF:
      "An integrated system for monitoring hazards, assessing risk, communicating warnings, and enabling timely action.",
    RESPONSE: "Response",
    RESPONSE_DEF:
      "Actions taken directly before, during, or immediately after an event to save lives and meet urgent needs.",
    RECOVERY: "Recovery",
    RECOVERY_DEF:
      "The process of restoring and improving livelihoods, services, infrastructure, and systems after a disaster.",
    BUILD_BACK_BETTER: "Build back better",
    BUILD_BACK_BETTER_DEF:
      "Using recovery and reconstruction to reduce future risk and improve resilience beyond pre-disaster conditions.",
    CONTINGENCY_PLANNING: "Contingency planning",
    CONTINGENCY_PLANNING_DEF:
      "Preparing specific operational plans and coordination arrangements for plausible emergency scenarios.",
    RISK_ASSESSMENT: "Risk assessment",
    RISK_ASSESSMENT_DEF:
      "A structured process to identify hazards, analyse consequences, and estimate risk to support decisions.",
    RISK_COMMUNICATION: "Risk communication",
    RISK_COMMUNICATION_DEF:
      "Two-way exchange of risk information among authorities, responders, stakeholders, and the public.",
    SITUATION_AWARENESS: "Situation awareness",
    SITUATION_AWARENESS_DEF:
      "A current and shared understanding of incident conditions, impacts, resources, and likely developments.",
    INCIDENT_COMMAND: "Incident command",
    INCIDENT_COMMAND_DEF:
      "A command and coordination structure for managing roles, decisions, and resources during incidents.",
    STAKEHOLDER: "Stakeholder",
    STAKEHOLDER_DEF:
      "Any organisation, group, or individual with a role, responsibility, or interest in preparedness, response, or recovery.",
    INTEROPERABILITY: "Interoperability",
    INTEROPERABILITY_DEF:
      "The ability of organisations, teams, and systems to work together effectively across procedures, data, and technology.",
    CAPABILITY_GAP: "Capability gap",
    CAPABILITY_GAP_DEF:
      "The difference between required and current capability levels needed to achieve target outcomes.",
    CAPABILITY_ASSESSMENT: "Capability assessment",
    CAPABILITY_ASSESSMENT_DEF:
      "A structured evaluation of capability importance and performance to identify priorities for improvement.",
    SOLUTION: "Solution",
    SOLUTION_DEF:
      "A measure, practice, technology, or intervention proposed to address one or more capability gaps.",
    SOLUTION_ASSESSMENT: "Solution assessment",
    SOLUTION_ASSESSMENT_DEF:
      "A systematic appraisal of candidate solutions against user needs, operational fit, impact, and compliance.",
    ROADMAP: "Roadmap",
    ROADMAP_DEF:
      "A phased implementation plan showing what will be delivered, by whom, and when.",
    IMPLEMENTATION_TIMELINE: "Implementation timeline",
    IMPLEMENTATION_TIMELINE_DEF:
      "The planned sequence and timing of activities, milestones, and deliverables for implementation.",
    PRIORITIZATION: "Prioritization",
    PRIORITIZATION_DEF:
      "Ranking actions or investments based on urgency, expected impact, feasibility, and available resources.",
    MONITORING_EVALUATION: "Monitoring and evaluation",
    MONITORING_EVALUATION_DEF:
      "Ongoing tracking and periodic review of progress, outcomes, and effectiveness to support learning and adjustment.",
    LESSONS_LEARNED: "Lessons learned",
    LESSONS_LEARNED_DEF:
      "Documented insights from operations and exercises used to improve future planning and performance.",
    SESSION: "Assessment session",
    SESSION_DEF:
      "A saved working context containing selected hazards, assessments, solutions, and roadmap data.",
    COMPLIANCE_CHECK: "Compliance check",
    COMPLIANCE_CHECK_DEF:
      "A verification that proposed solutions and actions meet legal, policy, ethical, and sector requirements.",
    TECHNOLOGY_READINESS_LEVEL: "Technology readiness level",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "A scale from 1 to 9 indicating the maturity of a technology from concept to operational deployment.",
  },
  term: "Term",
  title: "Title",
  upload: "Upload",
  url: "URL",
  value: "Value",
  yes: "Yes",
  TBD: "Unknown",
  general_settings: "General",
  enable_sol_ass_support: "Solution assessment enabled",
  logo: "User logo",
  attribution_logo: "Attribution logo",
  attribution_text: "Attribution text",
  order: "Order",
  hide: "Hide in overview",
  select_user: "Select user",
  user: "Regular user",
  moderator: "Moderator",
  admin: "Administrator",
  doc_title: "Capability Assessment Report",
  export_to_word: "Export to Word",
  export_all_to_word: "Export full report to Word",
  add_gap: "Add capability gap",
  ignore: "Not applicable",
  continue: "Continue",
  hazards: "Hazards",
  hazards_route: "/hazards",
  hazard_step_title: "Step 0: Initiation & Preparation",
  hazard_step_desc:
    "Select the hazard types relevant to the scope you want to address in this assessment workshop.",
  workshop_scope: "Workshop scope",
  hazard_category_all: "All",
  hazard_category_natural: "Natural",
  hazard_category_technical: "Technical",
  hazard_category_attack: "Attack",
  hazard_edit: "Edit hazard types",
  hazard_done: "Done editing",
  hazard_add: "Add New Hazard Type",
  hazard_name: "Hazard name",
  hazard_description: "Description / context",
  hazard_selected_count: "{n} hazard type(s) selected.",
  solutions: "Solutions",
  solution_count: {
    1: "1 solution",
    n: "{n} solutions",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Step 2: Solution Assessment",
  solutions_step_desc:
    "Add and assess solutions for identified capability gaps.",
  solution_add: "Add Solution",
  solution_new: "New Solution",
  solution_gaps_found: {
    1: "1 capability gap identified",
    n: "{n} capability gaps identified",
  },
  solution_empty:
    "No solutions added yet. Click 'Add Solution' to get started.",
  roadmap: "Roadmap",
  roadmap_count: {
    1: "1 roadmap item",
    n: "{n} roadmap items",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Step 3: Roadmapping",
  roadmap_step_desc:
    "Plan implementation timelines and commitments for your selected solutions.",
  roadmap_add_solutions: "Add {n} solution(s) to roadmap",
  roadmap_empty_solutions:
    "Complete Step 2 (Solution Assessment) first to add solutions to the roadmap.",
  roadmap_empty: "No roadmap items yet.",
  roadmap_timeline: "Timeline",
  session_create: "Create",
  session_new_name: "New session name",
  session_sessions: "Assessment Sessions",
  session_name: "Name",
  session_updated: "Last Updated",
  session_actions: "Actions",
  session_clone: "Clone session",
  session_download: "Download as JSON",
  session_delete: "Delete session",
  session_import: "Import JSON",
  session_delete_confirm: "Delete session: {name}?",
  session_delete_warning: "This cannot be undone. Are you sure?",
  dashboard_subtitle:
    "Follow the steps below to complete your disaster management assessment.",
  back_to_sessions: "Back to sessions",
  step0_title: "Initiation & Preparation",
  step1_title: "Needs & Gaps Assessment",
  step2_title: "Solution Assessment",
  step3_title: "Roadmapping",
  summary: "Summary",
  selected_hazards: "Selected Hazards",
  capability_gaps: "Capability Gaps",
  more: "more",
  partially: "Partially",
  not_assessed: "Not assessed",
  enabled_steps: "Enabled steps",
  priority_low: "Low",
  priority_medium: "Medium",
  priority_high: "High",
  sol_trl: "Technology Readiness Level",
  trl1: "Basic principles observed",
  trl2: "Technology concept formulated",
  trl3: "Experimental proof of concept",
  trl4: "Technology validated in lab",
  trl5: "Technology validated in relevant environment",
  trl6: "Technology demonstrated in relevant environment",
  trl7: "System prototype demonstrated in operational environment",
  trl8: "System complete and qualified",
  trl9: "Actual system proven in operational environment",
  sol_integration_rl: "Integration Readiness Level",
  sol_societal_rl: "Societal Readiness Level",
  sol_manufacturing_rl: "Manufacturing Readiness Level",
  sol_commercialisation_rl: "Commercialisation Readiness Level",
  sol_security_rl: "Security Readiness Level",
  sol_legal_privacy_ethical_rl: "Legal, Privacy & Ethical Readiness Level",
  integration_rl1: "A high-level concept for integration has been identified",
  integration_rl2:
    "Some specificity level of requirements for the component interaction",
  integration_rl3:
    "The detailed integration design has been defined to include all interface details",
  integration_rl4:
    "Validation of integrating component functions in a laboratory environment",
  integration_rl5:
    "Validation of integrating components in a relevant environment",
  integration_rl6:
    "Validation of integrating components in a relevant end-to-end environment",
  integration_rl7:
    "Prototype integration demonstration in an operational high-fidelity environment",
  integration_rl8: "Test and demonstration in an operational environment",
  integration_rl9:
    "Proven system integration through successful mission operations capabilities",
  societal_rl1:
    "Identification of the generic societal need, social good, and associated aspects",
  societal_rl2:
    "Formulation of proposed solution concept and potential impacts",
  societal_rl3:
    "A limited group of the society knows the solution or similar initiatives",
  societal_rl4:
    "A limited group of the society tests the solution or similar initiatives",
  societal_rl5:
    "Society knows the solution or similar initiatives but is not aware of their benefits",
  societal_rl6:
    "Society knows the solution and awareness of their benefits increases",
  societal_rl7: "Society is completely aware of the solution's benefits",
  societal_rl8:
    "Society is ready to adopt the solution and have used similar solutions on the market",
  societal_rl9:
    "Society is using the solution and it is supported by stakeholders and the public",
  manufacturing_rl1: "Basic manufacturing implications identified",
  manufacturing_rl2: "Manufacturing concepts identified",
  manufacturing_rl3: "Manufacturing proof of concept developed",
  manufacturing_rl4:
    "Capability to produce the technology in a laboratory environment",
  manufacturing_rl5:
    "Capability to produce the prototype components in a production relevant environment",
  manufacturing_rl6:
    "Capability to produce a prototype system or subsystem in a production relevant environment",
  manufacturing_rl7:
    "Capability to produce systems, subsystems or components in a production representative environment",
  manufacturing_rl8:
    "Pilot line capability demonstrated. Ready to begin low rate production",
  manufacturing_rl9:
    "Low rate production demonstrated. Capability in place to begin full rate production",
  commercialisation_rl1: "Research and basis hypothesis",
  commercialisation_rl2: "Market assessment",
  commercialisation_rl3: "Technology application and market validation",
  commercialisation_rl4: "Value proposition",
  commercialisation_rl5: "Product development and market alignment",
  commercialisation_rl6: "Product/solution optimisation and IP protection",
  commercialisation_rl7: "Technical and commercial validation",
  commercialisation_rl8: "Commercialisation strategy and market introduction",
  commercialisation_rl9: "Full launch and license revenue",
  security_rl1: "Security consideration",
  security_rl2: "Security concept development",
  security_rl3: "Security by design",
  security_rl4: "Security measures and features preparation",
  security_rl5: "Simple security validation",
  security_rl6: "Sequential security demonstration",
  security_rl7: "Complex security demonstrations",
  security_rl8: "Final pre-release security validation and preparation",
  security_rl9: "Initial operational security",
  security_rl10: "Well-established/reliable security",
  legal_privacy_ethical_rl1:
    "Control over legal, ethical, and privacy issues: the system has implemented control mechanisms for accountability and has passed standard benchmarks and obtained certification, if applicable",
  legal_privacy_ethical_rl2:
    "Ethical tensions addressed via ethics-by-design: the system's legal, ethical, and privacy considerations have been designed to be compatible with each other. Ethics tensions have been addressed so improving one aspect does not negatively impact another",
  legal_privacy_ethical_rl3:
    "Characterised legal, ethical, and privacy interactions: the interactions between different ethical and privacy considerations have been characterised",
  legal_privacy_ethical_rl4:
    "Identified legal, ethical, and privacy issues: ethical and privacy considerations raised by the system have been identified and anticipated",
  sol_linked_caps: "Linked capabilities (with gaps)",
  sol_addressed_gaps: "Addressed capability gaps",
  sol_no_gaps:
    "No capability gaps have been identified yet. Go to Step 1 to assess capabilities.",
  sol_compliance_title: "Compliance Checks",
  sol_status: "Status",
  sol_pass: "Pass",
  sol_partial: "Partial",
  sol_fail: "Fail",
  sol_na: "N/A",
  sol_not_applicable: "Not applicable",
  sol_user_needs_title: "User Needs Assessment",
  sol_operational_needs_title: "Operational Needs Assessment",
  sol_organisational_needs_title: "Organisational Needs Assessment",
  sol_expected_impact_title: "Expected Impact Assessment",
  sol_question: "Question",
  sol_response: "Response",
  // User Needs questions
  UN01: "Is the solution easy to use?",
  UN02: "Does the solution likely perform adequately under duress? Including robustness and reliability.",
  UN03: "Is the solution likely to be accepted by users?",
  UN04: "Is the solution likely to support user understandability?",
  UN05: "Is the solution likely to support user explainability?",
  UN06: "Is the solution likely to improve user efficiencies?",
  UN07: "Is the solution likely to improve user effectiveness?",
  UN08: "Is the solution likely to provide added knowledge?",
  UN09: "Is the solution likely to consistently produce positive interventions and/or results?",
  // Operational Needs questions
  ON01: "Is the solution likely to require extensive (re-)training?",
  ON02: "Is the solution likely to require excessive maintenance & support?",
  ON03: "Is the solution likely to be compatible with your operating methods/SoP?",
  ON04: "Is the solution interoperable?",
  ON05: "Is the solution likely to be adaptable and transferable across your operating scenarios?",
  ON06: "Is the solution likely to support responder health and safety?",
  ON07: "Is the solution likely to reach the intended target population?",
  ON08: "Is the solution likely to offer improved operational efficiencies?",
  ON09: "Is the solution likely to offer improved operational effectiveness?",
  // Organisational Needs questions
  OG01: "Is the solution likely to have a positive cost-benefit balance?",
  OG02: "Does the solution seem feasible? Including technologically, economically, legally, operationally, and scheduling.",
  OG03: "Is the solution likely to be compatible with your organisational culture?",
  OG04: "Is the solution likely to be compatible with your organisational mandate?",
  OG05: "Is the solution likely to be compatible with the priorities of CM governance?",
  OG06: "Would using the solution support your reputation amongst the public?",
  OG07: "Would using the solution help to improve community relations?",
  // Expected Impact questions
  EI01: "Will the solution be applied in the context of human healthcare?",
  EI02: "Does the solution involve the processing of personal data?",
  EI03: "Is the solution likely to have a negative impact on the rights & freedoms of individuals and groups? E.g. privacy, dignity, autonomy, solidarity.",
  EI04: "Is the solution likely to have a negative impact in terms of social justice and equality?",
  EI05: "Is the solution likely to have a negative impact on the well-being of individuals or groups?",
  EI06: "Is the solution likely to increase the vulnerability of individuals or groups?",
  EI07: "Is the solution likely to pose potential safety risks?",
  EI08: "Is the solution likely to have a negative impact on the environment?",
  EI09: "Is there SIGNIFICANT uncertainty regarding the legal, ethical, and societal impacts from the use of the solution?",
  // Compliance checks
  CC01: "(Cyber) Security",
  CC02: "Interoperability",
  CC03: "AI Act",
  CC04: "Community Engagement",
  CC05: "GDPR",
  CC06: "Fundamental Rights",
  CC07: "Sustainable Development Goals",
  CC08: "National level crisis management priorities",
  CC09: "Sector specific standards",
  CC10: "Sector specific laws & regulations",
  cap_add_from_ref: "Add capabilities from reference",
  cap_all_selected:
    "All reference capabilities have been added to your session.",
  cap_add_selected: "Add selected capabilities",
  cap_ref_panel_title: "Available capabilities (DASF reference model)",
  collapse: "Collapse",
  step0_abbr: "Step 0: I&P",
  step0_desc: "Identify relevant hazard types for your assessment context.",
  step1_abbr: "Step 1: NGA",
  step1_desc: "Assess capabilities, identify gaps and improvement needs.",
  step2_abbr: "Step 2: SA",
  step2_desc: "Evaluate solutions for identified capability gaps.",
  step3_abbr: "Step 3: RM",
  step3_desc: "Plan implementation roadmap and commitments.",
  landing_attribution:
    "DIREKTION has received funding from the European Union’s Horizon Europe research and innovation programme under grant agreement No 101121249.",
  landing_developed_by: "Developed by",
  landing_as_part_of: "as part of the",
  landing_project: "project.",
  dasf_purpose_title: "Purpose of the DASF",
  dasf_purpose_p1:
    "The DIREKTION Assessment and Screening Framework (DASF) is a core method developed within the DIREKTION project to support a transparent and impartial screening and assessment process.",
  dasf_purpose_offers: "The DASF Framework offers a step-by-step method to:",
  dasf_purpose_item1: "Identify and address capability gaps",
  dasf_purpose_item2:
    "Implement systematic screening of technologies and solutions",
  dasf_purpose_item3: "Set up a roadmap",
  dasf_purpose_p2:
    "The DASF provides the basis for a sustainable process for research programming, ensuring that responders and stakeholders have access to the most effective and up-to-date tools for disaster preparedness and response. The complete set is meant to be executed regularly — for instance, once a year or once every four years — to get an updated insight into the most current capability needs, capability gaps, potential solutions, and to regularly update the roadmap for EU or national research opportunities.",
  landing_assessment_process: "Assessment Process",
  landing_video_tutorial: "Watch the video tutorial on YouTube",
  landing_funded_by: "Funded by the European Union",
  landing_trilateral_attribution:
    "For the creation of this tool, essential contributions of Trilateral Research as developed in DIREKTION D1.2 were used.",
  delete_session_confirm: "Delete session: {name}?",
  delete_session_warning: "This cannot be undone. Are you sure?",
  // Hazard types (keys = hazard IDs)
  N01: "Earthquake",
  N02: "Tsunami",
  N03: "Volcanic eruption",
  N04: "Landslide / Avalanche",
  N05: "Flood",
  N06: "Flash flood",
  N07: "Storm / Hurricane / Tornado",
  N08: "Wildfire / Forest fire",
  N09: "Extreme temperature (heat/cold)",
  N10: "Drought",
  N11: "Epidemic / Pandemic",
  N12: "Animal disease outbreak",
  N13: "Insect infestation",
  T01: "Industrial accident (CBRN)",
  T02: "Nuclear / Radiological incident",
  T03: "Transportation accident (air)",
  T04: "Transportation accident (rail)",
  T05: "Transportation accident (road)",
  T06: "Transportation accident (maritime)",
  T07: "Pipeline / Gas explosion",
  T08: "Building / Structure collapse",
  T09: "Dam / Levee failure",
  T10: "Power outage / Grid failure",
  T11: "Telecommunications failure",
  T12: "Water supply contamination",
  T13: "Hazardous material spill",
  A01: "Terrorist attack (explosive)",
  A02: "Terrorist attack (CBRN)",
  A03: "Cyber attack",
  A04: "Active shooter / Armed assault",
  A05: "Sabotage of critical infrastructure",
  A06: "Hostage / Kidnapping situation",
  A07: "Civil unrest / Riots",
  A08: "Maritime piracy / Hijacking",
  A09: "Drone attack",
  A10: "Hybrid threat",
  A11: "Disinformation campaign",
  A12: "Supply chain disruption (intentional)",
  A13: "Arson",
  // Capability categories (keys = category IDs)
  "Cat-01": "Mitigation / Prevention",
  "Cat-02": "Preparedness",
  "Cat-03": "Response",
  "Cat-04": "Recovery",
  // Capability subcategories (keys = subcategory IDs)
  "Mit-01": "Risk assessment",
  "Mit-02": "Exposure reduction",
  "Mit-03": "Mitigation support",
  "Prep-01": "Capacity development",
  "Prep-02": "Monitoring",
  "Prep-03": "Preparedness support",
  "Rsp-01": "Suppress incident",
  "Rsp-02": "Rescue operations",
  "Rsp-03": "Security / Law enforcement",
  "Rsp-04": "Emergency Health Care",
  "Rsp-05": "Communicate to society",
  "Rsp-06": "Safeguard population / animals",
  "Rsp-07": "Disaster area clearance",
  "Rsp-08": "Basic needs supply",
  "Rsp-09": "Response support",
  "Rec-01": "Humanitarian recovery",
  "Rec-02": "Environmental recovery",
  "Rec-03": "Economic recovery",
  "Rec-04": "Re-establishment of infrastructure",
  "Rec-05": "Recovery support",
  // Capabilities (keys = capability IDs)
  "Mit-RA-01": "Risk identification",
  "Mit-RA-02": "Risk analysis",
  "Mit-RA-03": "Risk evaluation",
  "Mit-ER-01": "Property protection",
  "Mit-ER-02": "Natural resource protection",
  "Mit-ER-03": "Awareness raising",
  "Mit-MS-01": "Trend analysis",
  "Mit-MS-02": "Monitoring and review",
  "Prep-CD-01": "Response and recovery planning",
  "Prep-CD-02": "Training",
  "Prep-CD-03": "Risk communication",
  "Prep-MO-01": "Detection",
  "Prep-MO-02": "Alert",
  "Prep-PS-01": "Personnel management",
  "Prep-PS-02": "Asset management",
  "Prep-PS-03": "Cooperation establishment",
  "Prep-EH-04": "Psychological care",
  "Resp-SI-01": "Firefighting - Infrastructures",
  "Resp-SI-02": "Firefighting - Nature",
  "Resp-SI-03": "Flood control",
  "Resp-SI04": "Hazmat control (CBRN-E)",
  "Resp-RO-01": "Search and Rescue (SAR)",
  "Resp-RO-02": "On-site casualty treatment",
  "Resp-RO-03": "Transport of victims",
  "Resp-SL-01": "Securing locations / persons",
  "Resp-SL-02": "Identification of persons",
  "Resp-SL-03": "Forensics",
  "Resp-SL-04": "Maintain public order",
  "Resp-SL-05": "Traffic management",
  "Resp-EH-01": "Urgent care - Hospitals",
  "Resp-EH-02": "Quarantine",
  "Resp-EH-03": "Mass public health",
  "Resp-CS-01": "Warning",
  "Resp-CS-02": "Crisis communication",
  "Resp-SF-01": "Evacuate",
  "Resp-SF-02": "Shelter",
  "Resp-SF-03": "Reunification",
  "Resp-DA-01": "Debris clearance",
  "Resp-DA-02": "Decontamination of objects",
  "Resp-DA-03": "Draining",
  "Resp-DA-04": "Animal destruction",
  "Resp-BN-01": "Drinking water supply",
  "Resp-BN-02": "Food supply",
  "Resp-BN-03": "Energy supply",
  "Resp-BN-04": "Provision of ICT / Telecom",
  "Resp-BN-05": "Provide sanitation",
  "Resp-RS-01": "Command, Control and Coordination",
  "Resp-RS-02": "Situation assessment",
  "Resp-RS-03": "Information management",
  "Resp-RS-04": "Monitoring / Data collection",
  "Resp-RS-05": "On-site operations support",
  "Resp-RS-06": "Logistics",
  "Rec-HR-01": "Provide public health & safety",
  "Rec-HR-02": "Provide food and shelter",
  "Rec-ER-01": "Waste management",
  "Rec-ER-02": "Restoration habitats",
  "Rec-EC-01": "Business recovery",
  "Rec-EC-02": "Financial recovery",
  "Rec-RI-01": "Re-establish transport",
  "Rec-RI-02": "Re-establish utilities",
  "Rec-RS-01": "Establish recovery organisation",
  "Rec-RS-02": "Recovery programming",
  // mainTasks labels and descriptions
  "Goal-01": "Prevent incidents",
  "Goal-01_desc": "Prevent disasters / crisis situations.",
  "Goal-02": "Minimise losses from hazards",
  "Goal-02_desc": "Reduce / avoid losses from hazards.",
  "Goal-03": "Help victims",
  "Goal-03_desc": "Assure prompt effective assistance to victims.",
  "Goal-04": "Adequate recovery",
  "Goal-04_desc": "Achieve rapid and effective recovery.",
  // Stakeholder types (TO-01 through TO-09)
  "TO-01": "Fire brigade / Civil protection",
  "TO-02": "Police",
  "TO-03": "Emergency health care",
  "TO-04": "Defence",
  "TO-05": "Command centre",
  "TO-06": "Authorities",
  "TO-07": "Critical infrastructure",
  "TO-08": "NGO",
  "TO-09": "Other",
  // Stakeholders (SH-01 through SH-12)
  "SH-01": "Fire brigade/Civil protection",
  "SH-02": "Police",
  "SH-03": "Emergency health care",
  "SH-04": "SAR",
  "SH-05": "Command or Dispatch centre (112)",
  "SH-06": "Authorities (ministries, municipalities)",
  "SH-07": "Defence",
  "SH-08": "Public services",
  "SH-09": "Coast guard or Border security",
  "SH-10": "Critical infrastructure operator",
  "SH-11": "NGO",
  "SH-12": "Other (to be described)",
  // taskScale labels
  "Imp-1": "None/Very low",
  "Imp-2": "Low",
  "Imp-3": "Medium",
  "Imp-4": "Quite high",
  "Imp-5": "Very high",
  // performanceAspects labels and descriptions
  "PA-1": "Effectiveness",
  "PA-1_desc": "Quality of the results, timeliness, endurance.",
  "PA-2": "Safety/Security of professionals",
  "PA-2_desc": "Physical and mental safety of involved personnel.",
  "PA-3": "Efficiency",
  "PA-3_desc": "Relation between costs and results.",
  // performanceScale labels
  "PSc-1": "Poor",
  "PSc-2": "Unsatisfactory",
  "PSc-3": "Moderate",
  "PSc-4": "Satisfactory",
  "PSc-5": "Good",
  // mainGaps labels and descriptions
  "Nat-01": "Technological",
  "Nat-01_desc":
    "E.g., Sensing Technologies, Command and control, communications and coordination, ICT.",
  "Nat-02": "Human",
  "Nat-02_desc":
    "E.g., Amount of personnel, Competence of personnel, Training and education.",
  "Nat-03": "Organizational",
  "Nat-03_desc":
    "E.g., Procedures, Organizational structure, Financial Aspects, Agreements.",
  "Nat-04": "Regulatory",
  "Nat-04_desc": "E.g., Legal Aspects, Formal Standardization aspects.",
  // gapScale labels
  "Kn-01": "Unknown",
  "Kn-02": "No",
  "Kn-03": "Yes",
  // assessmentScale labels
  "ASc-01": "Very low",
  "ASc-02": "Low",
  "ASc-03": "Moderate",
  "ASc-04": "High",
  "ASc-05": "Very high",
  // Category descriptions
  "Cat-01_desc":
    "Objective: To take measures to limit the probability and to reduce the impact of an incident, disaster or crises.",
  "Cat-02_desc":
    "Objective: To develop and maintain the organisation structure and the capabilities to carry out response and recovery activities.",
  "Cat-03_desc": "Objective: To save lives and to limit adverse effects.",
  "Cat-04_desc":
    "Objective: To reconstruct and restore normal life in an efficient way.",
  // Subcategory descriptions
  "Mit-01_desc": "Identification, analysis and evaluation of risks.",
  "Mit-02_desc":
    "Protection of properties, natural resources and society in general from hazards.",
  "Mit-03_desc": "Capabilities in support of Mitigation / Prevention.",
  "Prep-01_desc":
    "Process of developing and maintaining required crisis management capacities.",
  "Prep-02_desc":
    "Determine the status of an environment or situation to enable detection of incidents.",
  "Prep-03_desc": "Capabilities in support of capacity development.",
  "Rsp-01_desc":
    "On-site activities to stop or to contain the cause of the disaster.",
  "Rsp-02_desc": "On-site activities to save lives.",
  "Rsp-03_desc":
    "Securing areas/persons, Identification of persons, Forensics.",
  "Rsp-04_desc": "Off-site activities to save lives.",
  "Rsp-05_desc": "Warning and Crisis communication.",
  "Rsp-06_desc": "Controlled evacuation of persons and/or animals.",
  "Rsp-07_desc": "Arrange accessibility to and safety in the affected area.",
  "Rsp-08_desc":
    "Supply and/or restoration of basic products and services of vital importance.",
  "Rsp-09_desc":
    "Capabilities to enable one or more other response capabilities.",
  "Rec-01_desc": "Provision of public health and safety services and shelter.",
  "Rec-02_desc": "Clearance of pollution and decontamination.",
  "Rec-03_desc": "Economic and business recovery.",
  "Rec-04_desc": "Restoration of transport routes and essential services.",
  "Rec-05_desc": "Capabilities required to recover in a well-coordinated way.",
  // Capability descriptions
  "Mit-RA-01_desc": "Process of finding, recognising and describing risk.",
  "Mit-RA-02_desc":
    "Process to comprehend the nature of risk and to determine the level of risk.",
  "Mit-RA-03_desc":
    "Process of comparing the results of risk analysis with risk criteria to determine whether the risk and/or its magnitude is acceptable or tolerable.",
  "Mit-ER-01_desc": "Property protection (incl. critical infrastructures).",
  "Mit-ER-02_desc":
    "Actions that minimize hazard losses and preserve or restore the functions of natural systems.",
  "Mit-ER-03_desc":
    "Public education and awareness raising about hazards and potential ways to mitigate them.",
  "Mit-MS-01_desc": "Investigation of the evolution of risks.",
  "Mit-MS-02_desc":
    "Ensuring controls are effective and efficient, obtaining further information to improve risk assessment.",
  "Prep-CD-01_desc":
    "Develop, compile and maintain procedures and information in readiness for use in an incident.",
  "Prep-CD-02_desc":
    "Activities to facilitate learning and development of knowledge, skills, and abilities for disaster response.",
  "Prep-CD-03_desc":
    "Communicating and instructing the public how to be well-prepared for a crisis and how to behave when it occurs.",
  "Prep-MO-01_desc": "Detection of circumstances deviating from normal.",
  "Prep-MO-02_desc":
    "Alert personnel to the presence of an incident and allow control actions to be initiated.",
  "Prep-PS-01_desc":
    "Activities to provide enough and skilled personnel required to carry out response and recovery tasks.",
  "Prep-PS-02_desc":
    "Activities to provide equipment, tools, ICT and other assets required to enable response and recovery.",
  "Prep-PS-03_desc":
    "International cooperation establishment between emergency services and third parties.",
  "Prep-EH-04_desc":
    "Psychological health care to victims, relatives and other people affected by the incident.",
  "Resp-SI-01_desc":
    "Fighting fires in buildings, built-up areas or at infrastructures.",
  "Resp-SI-02_desc": "Fighting fires in natural environments.",
  "Resp-SI-03_desc":
    "Water management in case of a flooding due to a dike burst or heavy rainfall.",
  "Resp-SI04_desc":
    "Stop spill of hazardous materials, including containment (CBRN-E incidents).",
  "Resp-RO-01_desc": "Search and rescue operations.",
  "Resp-RO-02_desc": "Triage, decontamination and stabilisation of victims.",
  "Resp-RO-03_desc": "Ambulance transport to safe areas or hospitals.",
  "Resp-SL-01_desc":
    "Protect areas, infrastructures, and persons from uninvolved parties.",
  "Resp-SL-02_desc": "Identification of victims.",
  "Resp-SL-03_desc":
    "Forensic activities to investigate the cause of the incident and safeguard evidence.",
  "Resp-SL-04_desc": "Riot control, etc.",
  "Resp-SL-05_desc":
    "Traffic control both in-going and out-going the affected area.",
  "Resp-EH-01_desc": "Health service in regular and/or field hospitals.",
  "Resp-EH-02_desc": "Isolation of potentially infectious persons/victims.",
  "Resp-EH-03_desc":
    "Mass prophylaxis or vaccination in case of a nuclear incident or pandemic.",
  "Resp-CS-01_desc":
    "Warn society in the threatened zone by providing timely and adequate information on the threat.",
  "Resp-CS-02_desc":
    "Providing information on the disaster to the society including volunteer management and appeals.",
  "Resp-SF-01_desc":
    "Controlled evacuation of persons and animals from a certain area or building.",
  "Resp-SF-02_desc":
    "Provision of shelter to evacuees, including nutrition and sanitation.",
  "Resp-SF-03_desc": "Reunification of evacuees with their relatives.",
  "Resp-DA-01_desc": "Removal of debris and/or contaminated material.",
  "Resp-DA-02_desc":
    "Decontamination of contaminated areas, infrastructures and/or vehicles.",
  "Resp-DA-03_desc":
    "Draining and pumping of inundated areas or infrastructures.",
  "Resp-DA-04_desc": "Destruction of potentially infected animals.",
  "Resp-BN-01_desc": "Restoration or temporary provision of drinking water.",
  "Resp-BN-02_desc": "Temporary provision of food.",
  "Resp-BN-03_desc":
    "Restoration of electricity/gas supply or provision of temporary alternative energy.",
  "Resp-BN-04_desc":
    "Restoration or temporary supply of ICT and Telecommunication.",
  "Resp-BN-05_desc": "Restore sanitation or provide temporary solutions.",
  "Resp-RS-01_desc":
    "Decision-making, planning and tasking at coordination and command levels managing a disaster event.",
  "Resp-RS-02_desc":
    "Development of operational information through enrichment of collected data, including Common Operational Picture.",
  "Resp-RS-03_desc":
    "Storing and sharing of information such as collected data, assessments and decisions taken.",
  "Resp-RS-04_desc":
    "Collection of data by physical monitoring (surveillance) and data-mining.",
  "Resp-RS-05_desc":
    "Supply of basic services to first responders on-site to enable response activities.",
  "Resp-RS-06_desc":
    "Transport of personnel and materiel to support sustained disaster response operations.",
  "Rec-HR-01_desc":
    "Provision of public health and safety services for those displaced.",
  "Rec-HR-02_desc": "Provision of food and shelter for those displaced.",
  "Rec-ER-01_desc":
    "Clearance of large-scale pollution and decontamination, and dealing with waste.",
  "Rec-ER-02_desc": "Restoration of natural resources and habitats.",
  "Rec-EC-01_desc":
    "Business recovery of shops and industry that suffered from the disaster.",
  "Rec-EC-02_desc": "Recovery from financial impact on authorities.",
  "Rec-RI-01_desc":
    "Re-establishment of transport routes (road, rail, water, air, pipelines).",
  "Rec-RI-02_desc":
    "Restoration of interrupted utilities and other essential services.",
  "Rec-RS-01_desc":
    "Establishment of recovery organisation structure for both short-term and long-term recovery.",
  "Rec-RS-02_desc":
    "Determination and implementation of recovery programme based on impact assessment.",
  // Overview UI
  manage_capabilities: "Select capabilities",
  select_capabilities_instr:
    "Select the capabilities that you want to assess for gaps.",
  // Context drawer
  drawer_hazards: "Hazards",
  drawer_gaps: "Gaps",
  drawer_solutions: "Solutions",
  drawer_roadmap: "Roadmap",
  drawer_capabilities: "Capabilities",
  drawer_solution: "Solution",
  drawer_with_gaps: "with gaps",
  drawer_no_linked_caps: "No linked capabilities",
  drawer_add_to_roadmap: "Add to roadmap →",
  drawer_go_to_solutions: "Go to solutions →",
  drawer_go_to_roadmap: "Go to roadmap →",
  drawer_none: "None",
  drawer_relevant_hazards: "Relevant hazards",
  // Assessment action priority
  action_priority: "Action priority",
  action_priority_instr:
    "Rate your willingness to act upon improving this capability (1 = low, 5 = urgent)",
  action_priority_label_1: "Not now",
  action_priority_label_3: "Maybe",
  action_priority_label_5: "Urgent",
  // Assessment navigation
  prev_cap: "Previous",
  next_cap: "Next",
  // test1234: {
  //   plural: {
  //     other: "{count} stakeholders",
  //     one: "1 stakeholder",
  //   },
  // },
  // ── Collaboration ──────────────────────────────────────────────────────────
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Done — Send Results",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

The DASF toolset supports the systematic assessment and screening process for disaster management. It provides a structured 4-step approach:

1. **Initiation & Preparation (I&P)**: Identify relevant hazard types and define the assessment scope.
2. **Needs & Gaps Assessment (NGA)**: Assess capabilities across the disaster management cycle, identify gaps and improvement needs.
3. **Solution Assessment (SA)**: Evaluate potential solutions for identified capability gaps, including compliance, user needs, and impact assessment.
4. **Roadmapping (RM)**: Plan implementation timelines and commitments for selected solutions.

##### Getting Started

- Create or open an assessment session from the landing page
- Navigate through the 4 steps using the toolbar icons
- Switch between User and Editor roles using the selector below

##### Roles

- **Regular User**: Can fill out assessments and view results
- **Moderator**: Can edit framework configuration (hazard types, capabilities, stakeholders)
- **Administrator**: Can modify assessment scales and settings

##### Background

This project has received funding from the European Union's Horizon 2020 research and innovation programme. Developed by TNO as part of the [DIREKTION](https://www.direktion-network.org) project.`,
};

export type Messages = typeof messages;
type StringMessageKey<M> = {
  [K in keyof M]-?: M[K] extends string ? K : never;
}[keyof M];

export type TranslationKey = StringMessageKey<Messages>;
